import React from 'react';
import { useTranslation } from 'react-i18next';
import { get, set } from '@totalsoft/change-tracking-react';
import { Grid } from '@mui/material';
import { Button } from '@totalsoft/rocket-ui';
import { Prompt } from 'react-router-dom';
import { TextField } from '@totalsoft/rocket-ui';
import { textResourceModalVar, defaultTextResource } from '../../variables';
import { emptyString } from 'utils/constants';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { useSubscription } from 'hooks/apollo';
import PropTypes from 'prop-types';
import { TEXT_RESOURCE_CHANGED } from 'features/textResource/subscriptions';

const AddTextResourceComponent = ({ isDirty, textResourceLens, handleSave, saving, validation, errorMessage }) => {
  const { t } = useTranslation();

  useSubscription(TEXT_RESOURCE_CHANGED, {
    onData: ({ client }) => {
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'pagedTextResources' });
      client.cache.gc();
      textResourceModalVar({ open: false, saving: false });
    }
  });

  return (
    <>
      <Prompt when={isDirty} message={t('LeavingWithoutSaving')} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('TextResource.TextResourceCode')}
            id='text-resource-code'
            value={get(textResourceLens.textResourceCode)}
            onChange={set(textResourceLens.textResourceCode)}
            error={!isValid(validation.textResourceCode) || errorMessage}
            helperText={getErrors(validation.textResourceCode) || errorMessage}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('TextResource.Label')}
            id='text-resource-label'
            value={get(textResourceLens.label)}
            onChange={set(textResourceLens.label)}
            error={!isValid(validation.label)}
            helperText={getErrors(validation.label)}
            disabled={false}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('TextResource.LabelENU')}
            id='text-resource-labelENU'
            value={get(textResourceLens.labelENU)}
            onChange={set(textResourceLens.labelENU)}
            disabled={false}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('TextResource.LabelFRA')}
            id='text-resource-labelFRA'
            value={get(textResourceLens.labelFRA) || emptyString}
            onChange={set(textResourceLens.labelFRA)}
            disabled={false}
          />
        </Grid>
        <Grid container gap={1} item xs={12} justifyContent='flex-end'>
          <Button onClick={handleSave} disabled={!isDirty || saving || errorMessage}>
            {saving ? t('Saving') : t('Save')}
          </Button>
          <Button
            onClick={() => {
              textResourceModalVar({ open: false, detail: defaultTextResource });
              set(textResourceLens)(defaultTextResource);
            }}
            disabled={saving}
          >
            {t('Close')}
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

AddTextResourceComponent.propTypes = {
  isDirty: PropTypes.bool.isRequired,
  textResourceLens: PropTypes.object.isRequired,
  handleSave: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  validation: PropTypes.object.isRequired,
  errorMessage: PropTypes.string
};

export default AddTextResourceComponent;
